// 定义 Store
export const useMenuStore = defineStore(
  'menu',
  () => {
    const menuList: any = ref([]);
    const setMenuList = async (val: any) => {
      menuList.value = val;
    };

    return {
      menuList,
      setMenuList,
    };
  },
  {
    persist: true,
  }
);
